import React from "react";
import "../../App.css";
import SummaryOfAccount from "../SummaryOfAccount";

function AccountSummary({ sessionObject }) {
  return (
    <div className="page-account-summary">
      <SummaryOfAccount sessionObject={sessionObject} />
    </div>
  );
}

export default AccountSummary;
